import { showMessage } from './messages.js'

/**
 * Share buttons carry their spoiler-free text in `data-share-text` (see
 * GameSession.share_text). The finished modal is swapped in by htmx, so
 * listen on the document rather than binding to the buttons directly.
 *
 * Touch devices get the native share sheet; everything else copies to the
 * clipboard and confirms with a toast. Desktop browsers also implement
 * navigator.share, but their share sheets are a poor fit for pasting into a
 * chat, so they're excluded.
 */
const useShareSheet = (text) =>
    window.matchMedia('(pointer: coarse)').matches &&
    navigator.canShare?.({ text })

document.addEventListener('click', async (event) => {
    const button = event.target.closest('.share-button')
    if (!button) return

    const text = button.dataset.shareText
    if (!text) return

    // No clipboard fallback after a failed share: the await has used up the
    // click's user activation, so the clipboard write would be refused too.
    if (useShareSheet(text)) {
        try {
            await navigator.share({ text })
        } catch (error) {
            // The user closing the share sheet isn't a failure.
            if (error.name !== 'AbortError') {
                showMessage("Couldn't share - try again")
            }
        }
        return
    }

    try {
        await navigator.clipboard.writeText(text)
        showMessage('Copied to clipboard!')
    } catch {
        showMessage("Couldn't copy - try again")
    }
})
